export const DATA_KEYS = {
  TASKS: 'task',
  DASHBOARDS: 'dashboards',
  GROUPS: 'groups',
  INSIGHTS: 'insights'
}